<template>
    <div class="container-fluid">
        <div class="row">
            <Menu />
            <div class="col-md-10 mt-4">
                <h1> <i class="fa-solid fa-diagram-project"></i> Cadastrar um novo Grupo
                    <RouterLink style="float:right; position:relative; top:-10px;" to="/dashboard" class="btn btn-primary"> <i class="fa-light fa-arrow-turn-down-left"></i> Voltar</RouterLink>
                </h1>
                <hr />
                 <div class="cont">
                    <Loading v-if="exibeLoading" />
                    <form v-if="!exibeLoading" @submit.prevent="handleProjeto">
                        <label class="mt-2">Nome do Grupo</label>
                        <div class="form-group mb-3">
                            <input type="text" v-model="form.name" placeholder="Nome do grupo" class="form-control" required/>
                        </div>

                        <div class="form-group mb-3">
                            <label class="mt-2">Selecione a recuperanda</label>
                            <select v-model="form.id_recuperanda" style="height:60px;" class="form-control mt-2" required>
                                <option v-for="reck in dadosRecuperanda" :key="reck.id" :value="reck.id">{{ reck.name }}</option>
                            </select>
                        </div>
                        <!-- <div class="form-group mb-3">
                            <label class="mt-2">Selecione a Classe</label>
                            <select v-model="form.id_classe" style="height:60px;" class="form-control mt-2" required>
                                <option v-for="reck in dadosClasses" :key="reck.id" :value="reck.id">{{ reck.name }}</option>
                            </select>
                        </div> -->
                        <button style="margin-left:0px;" class="btn btn-primary mt-4">Cadastrar</button>
                    </form>
                    <Alert style="margin-top:20px;" v-if="exibeAlert" :tipo="tipoS" :msg="msgS" />
            </div>
            </div>
        </div>
    </div>
    </template>

<script setup>
import { ref, onMounted } from 'vue';
import Menu from '@/components/Menu.vue';
import Alert from '@/components/Alert.vue';
import Loading from '@/components/Loading.vue';
import classes from '@/servicos/classes';
import recuperanda from '@/servicos/recuperanda';
import projetos from '@/servicos/projetos';

const form = ref({
    name: '',
    id_classe: '',
    id_recuperanda: ''

})

const dadosRecuperanda = ref([])
const dadosClasses = ref([])

const buscaRecuperanda = async () => {
    const response = await recuperanda.getAll();
    dadosRecuperanda.value = response.data
}

const buscaClasses = async () => {
    const response = await classes.getAll();
    dadosClasses.value = response.data
}



const exibeAlert = ref(false)
const tipoS = ref('')
const msgS = ref('')
const exibeLoading = ref(false)

const handleProjeto = async () => {
    exibeLoading.value = true
    const response = await projetos.create(form.value)

    if(response.data.response){
        exibeAlert.value = true
        tipoS.value = 'danger',
        msgS.value = response.response.data.message
        exibeLoading.value = false
    }

    if(response.data.id){
        exibeAlert.value = true
        tipoS.value = 'success',
        msgS.value = "Projeto cadastrado com sucesso"
        form.value.name = ''
        form.value.id_classe = ''
        form.value.id_recuperanda = ''
        exibeLoading.value = false
    }
}

onMounted(() => {
    buscaRecuperanda()
    buscaClasses()
})

</script>


    <style>
    
    h1 { color:rgba(0,0,0,.8); font-weight: 400; font-size:20px !important;}
    /* .table>:not(caption)>*>* { background-color:#1B3639;  } */
    th {color:rgba(255,255,255,.9) !important; padding:10px !important;}
    th { background-color: #1B3639 !important;}
    .cont { background:#fff; padding: 10px; border:1px solid rgba(0,0,0,.1); box-shadow:1px 2px 3px rgba(0,0,0,.4); }
    
    </style>